import React, {useEffect, useState} from 'react';
import {Modal} from "react-bootstrap";
import {Select} from "antd";
import {Controller, useForm} from "react-hook-form";
import api from "../../api/apiInterceptor";
import Loader from "../ApplicationComponent/Loader";
import ErrorIcon from "../../images/errorIcon.png";
import {CHANGING_USERNAME, REQUIRED_FIELD} from "../../constants/Messages";
import {useDispatch, useSelector} from "react-redux";
import {getAllInstallationsWithoutPag, getUserInfo} from "../../redux-store/selectors";
import {getAllUsers} from "../../redux-store/users";
import {checkSuperUser} from "../authHelpers";

const {Option} = Select

const defaultValues = {
    username: "",
    password: "",
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    fcmTokenSet: false,
    installationIds: [],
    role: ""
}

function UserForm({showModal, setShowModal, editId, setEditId, installationId}) {

    const {
        handleSubmit,
        formState: {isSubmitSuccessful, errors},
        setError,
        register,
        control,
        setValue,
        reset,
        watch
    } = useForm()
    const dispatch = useDispatch();
    const userInfo = useSelector(getUserInfo)
    const installations = useSelector(getAllInstallationsWithoutPag);
    const [formDataLoader, setFormDataLoader] = useState(false)
    const [installationSelectOptions, setInstallationSelectOptions] = useState([])
    const selectWatch = watch("role");

    const handleCloseModal = (e) => {
        e.preventDefault()
        setShowModal(false)
        setEditId(null)
    }

    const roleOptions = [<>
        {!checkSuperUser(userInfo) && <Option key={1} value={"ADMIN"}>{"ADMIN"}</Option>}
        <Option key={2} value={"USER"}>{"USER"}</Option>
        <Option key={3} value={"SUPERUSER"}>{"SUPERUSER"}</Option>
        <Option key={4} value={"VIEWER"}>{"VIEWER"}</Option>
    </>]

    useEffect(() => {
        const selectedData = installations?.map((item) => {
            return (<Option key={item.id} value={item.id}>{item.name}</Option>)
        });
        setInstallationSelectOptions(selectedData);
    }, [installations]);


    const fetchEditObject = async () => {
        setFormDataLoader(true)
        const result = await api.get(`/api/users/${editId}`)
        reset({
            username: result.data.username,
            email: result.data.email,
            firstName: result.data.firstName,
            lastName: result.data.lastName,
            phoneNumber: result.data.phoneNumber,
            fcmTokenSet: result.data.fcmTokenSet,
            installationIds: result.data.installationIds,
            role: result.data.role
        })
        setFormDataLoader(false)
    }

    useEffect(() => {
        if (showModal) {
            if (editId) {
                fetchEditObject()
            } else {
                reset(defaultValues)
                if (checkSuperUser(userInfo)) {
                    setValue("role", "USER")
                } else {
                    setValue("role", "ADMIN")
                }
            }
        }
    }, [showModal])

    useEffect(() => {
        if (isSubmitSuccessful) {
            reset(defaultValues)
        }
    }, [isSubmitSuccessful])


    const submitForm = async (data) => {
        try {
            if (data.role === "ADMIN") {
                data.installationIds = []
            }
            if (editId) {
                await api.put(`/api/users/${editId}`, data)
                setEditId(null)
            } else {
                await api.post("/api/users", data)
            }
            setShowModal(false)
            dispatch(getAllUsers({usersId: installationId}))
        } catch (err) {
            if (err.response.data.username) {
                setError("username", {message: CHANGING_USERNAME})
            }
        }
    }


    return (
        <Modal
            show={showModal}
            onHide={() => {
                setShowModal(false)
                setEditId(null)
            }}
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <Modal.Header closeButton className={"modal-header-component"}>
                <Modal.Title>{!editId ? "Dodavanje novog korisnika" : "Izmjena podataka o korisniku"}</Modal.Title>
            </Modal.Header>
            <Modal.Body className={"modal-body-users"}>
                {formDataLoader ? <Loader/> : (
                    <div className={"container"}>
                        <form onSubmit={handleSubmit(submitForm)}>
                            <h5 className={"form-title-h5"}>Korisnikov nalog</h5>
                            <hr/>
                            <div className={"row"}>
                                <div className={"col-12 col-12 col-lg-6 col-xl-6"}>
                                    <label className="mb-2 form-label" htmlFor="username">Korisničko ime</label>
                                    <input type="text"
                                           className="form-control"
                                           name={"username"}
                                           {...register("username", {required: REQUIRED_FIELD})}/>
                                    <div className={"row"}>
                                        <div className={"col-12"}>
                                            {errors.username && (
                                                <span className="loggin-error"><img
                                                    src={ErrorIcon}/> {errors.username.message}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={"col-12 col-12 col-lg-6 col-xl-6"}>
                                    <label className="mb-2 form-label" htmlFor="email">Email</label>
                                    <input type="text" className="form-control" name="email" {...register("email")}/>
                                </div>
                            </div>
                            <div className={"row mt-3"}>
                                <div className={"col-12 col-12 col-lg-6 col-xl-6"}>
                                    {!editId && <div className="mb-4">
                                        <label className="mb-2 form-label" htmlFor="password">Lozinka</label>
                                        <input type="password" className="form-control"
                                               name="password"
                                               aria-invalid={errors.password ? "true" : "false"}
                                               {...register("password", {required: true})}/>
                                        {errors.password && (
                                            <span className="loggin-error"><img
                                                src={ErrorIcon}/> {REQUIRED_FIELD}</span>
                                        )}
                                    </div>}
                                </div>
                                <div className={"col-12 col-12 col-lg-6 col-xl-6 form-modal-select"}>
                                    <label className="mb-2 form-label" htmlFor="role">Rola</label>
                                    <Controller
                                        control={control}
                                        name={"role"}
                                        render={({
                                                     field: {onChange, value, ref},
                                                 }) => (<Select
                                            onChange={onChange}
                                            value={value}
                                            ref={ref}
                                            className={"form-select"}
                                            getPopupContainer={node => node.parentNode}
                                        >
                                            {roleOptions}
                                        </Select>)}
                                        rules={{required: true}}
                                    />
                                    {errors.role && (
                                        <span className="loggin-error"><img src={ErrorIcon}/> {REQUIRED_FIELD}</span>
                                    )}
                                </div>
                            </div>
                            <h5 className={"form-title-h5 mt-3"}>Korisnikove informacije</h5>
                            <hr/>
                            <div className={"row mt-3"}>
                                <div className={"col-12 col-12 col-lg-6 col-xl-6"}>
                                    <label className="mb-2 form-label" htmlFor="firstName">Ime</label>
                                    <input type="text" className="form-control"
                                           name="firstName" {...register("firstName")}/>
                                </div>
                                <div className={"col-12 col-12 col-lg-6 col-xl-6"}>
                                    <label className="mb-2 form-label" htmlFor="lastName">Prezime</label>
                                    <input type="text" className="form-control"
                                           name="lastName" {...register("lastName")}/>
                                </div>
                            </div>
                            <div className={"row mt-3"}>
                                <div className={"col-12"}>
                                    <label className="mb-2 form-label" htmlFor="phoneNumber">Telefon</label>
                                    <input type="text" className="form-control"
                                           name="phoneNumber" {...register("phoneNumber")}/>
                                </div>
                            </div>
                            <h5 className={"form-title-h5 mt-4"}>Korisnikova odgovornost</h5>
                            <hr/>
                            <div className={"row mt-3"}>
                                <div className={"col-12 col-12 col-lg-6 col-xl-6"}>
                                    <div><label className="mb-2 form-label" htmlFor="fcmToken">FCM Token</label></div>
                                    <input type={"checkbox"} className={"form-check-input mr-5"} disabled={true}
                                           name={"fcmTokenSet"} {...register("fcmTokenSet")}/>
                                </div>
                                {selectWatch !== "ADMIN" &&
                                <div className={"col-12 col-12 col-lg-6 col-xl-6 choose-form-modal"}>
                                    <label className="mb-2 form-label" htmlFor="installationIds">Dodjeljene
                                        Instalacije</label>
                                    <Controller
                                        control={control}
                                        name={"installationIds"}
                                        render={({
                                                     field: {onChange, value, ref},
                                                 }) => (<Select
                                            showSearch
                                            mode="multiple"
                                            onChange={onChange}
                                            value={value}
                                            ref={ref}
                                            className={"form-select"}
                                            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                            getPopupContainer={node => node.parentNode}
                                        >
                                            {installationSelectOptions}
                                        </Select>)}
                                    />
                                </div>}
                            </div>
                            <div className={"modal-footer-component mt-3"}>
                                <button className={"btn btn-modal-cancel"} onClick={handleCloseModal}>
                                    {"Otkaži"}
                                </button>
                                <button className={"btn btn-modal-confirm"}>{editId ? "Ažuriraj" : "Kreiraj"}</button>
                            </div>
                        </form>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default UserForm;